import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import ListIcon from "@material-ui/icons/List";
import MapIcon from "@material-ui/icons/Map";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Box from "@material-ui/core/Box";
import IconLabelButton from "../MyButton";
import Grid from "@material-ui/core/Grid";
import Moment from "react-moment";
import Container from "@material-ui/core/Container";
import { sizing, maxHeight } from "@material-ui/system";
import { Height } from "@material-ui/icons";
import MyButton from "../MyButton";
import CircularProgress from "@material-ui/core/CircularProgress";

import CoQuanEditDialog from "./CoQuanEditDialog";

const server = require("../../lib/server.js");
const myLib = require("../../lib/MyLib.js");

const columns = [
  { field: "id", headerName: "STT", width: 70 },
  { field: "MaCQ", headerName: "Mã số", width: 80 },
  { field: "TenCoQuan", headerName: "Tên cơ quan", width: 230 },
  { field: "TenVietTat", headerName: "Tên viết tắt", width: 230 },
  { field: "Code", headerName: "Ký hiệu", width: 230 },
  { field: "NguoiCN", headerName: "Người CN", width: 120 },
  {
    field: "NgayCN",
    headerName: "Ngày CN",
    width: 130,
    renderCell: (params) => (
      <Moment format="DD-MM-yyyy HH:mm">{params.getValue("NgayCN")}</Moment>
    ),
  },
];

class CoQuanPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: { Page: 1, PageSize: 10 }, //dieu kien tim kiem hien thoi
      search_loading: false,
      errorLog: "",
      dataRows: [], //danh sach ban ghi
      totalRows: 0, //tong so ban ghi
      open_them_sukien: false, //hien thi form nhap moi su kien
      open_chitiet_sukien: false,
      open_edit_sukien: false, //hien thi form edit su kien
      Editting_MaCQ: undefined,
      showConfirmXoa: false,
    };
  }

  componentDidMount() {
    this.handleSearch();
  }
  handleSearch = () => {
    this.setState({ search_loading: true, errorLog: "" });
    server
      .query("coquan/gettimkiem")
      .then((response) => {
        response.map((item, index) => {
          item.id = index + 1;
        });
        this.setState({
          errorLog: "",
          search_loading: false,
          dataRows: response,
          totalRows: response.length,
        });
      })
      .catch((error) =>
        this.setState({
          saving: false,
          search_loading: false,
          errorLog: error + "",
        })
      );
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <Box display="flex">
          <MyButton
            onClick={() => this.handleSearch()}
            color="primary"
            text="Tìm kiếm"
          />
          {this.state.search_loading ? <CircularProgress /> : null}
          {this.state.errorLog !== "" ? this.state.errorLog : undefined}
        </Box>

        <Box flexGrow={1}>
          <DataGrid
            rows={this.state.dataRows}
            columns={columns}
            id="MaCQ"
            autoHeight
            rowHeight={32}
            className={classes.gridContainer}
            pagination
            pageSize={this.state.search.PageSize}
            rowCount={this.state.totalRows}
            paginationMode="server"
            sortingMode="server"
            menuContainerStyle={{ zIndex: 999 }}
            onPageChange={this.handlePageChange}
            onCellClick={(params) => {
              console.log(params);
              this.setState({
                Editting_MaCQ: params.data.MaCQ,
              });
            }}
          />
        </Box>
        <Box>
          <IconLabelButton
            variant="contained"
            color="primary"
            disabled={!global.User.Quyen.R111}
            size="normal"
            icon={<AddCircleIcon />}
            text={"Thêm mới"}
            onClick={() => {
              this.setState({ open_them_sukien: true });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            disabled={
              this.state.Editting_MaCQ === undefined || !global.User.Quyen.R111
            }
            icon={<EditIcon />}
            text={"Sửa"}
            onClick={() => {
              this.setState({
                open_edit_sukien: true,
                showConfirmXoa: false,
              });
            }}
          />
          <IconLabelButton
            variant="contained"
            color="primary"
            size="normal"
            disabled={
              this.state.Editting_MaCQ === undefined || !global.User.Quyen.R111
            }
            icon={<DeleteIcon />}
            text={"Xóa"}
            onClick={() => {
              this.setState({
                open_edit_sukien: true,
                showConfirmXoa: true,
              });
            }}
          />
        </Box>

        {this.state.open_them_sukien ? (
          <CoQuanEditDialog
            visible={this.state.open_them_sukien}
            fullWidth={true}
            maxWidth={"sm"}
            EditMode="them"
            onClose={(result) => {
              this.setState({ open_them_sukien: false }, () =>
                this.handleSearch()
              );
            }}
          />
        ) : null}
        {this.state.open_edit_sukien ? (
          <CoQuanEditDialog
            visible={this.state.open_edit_sukien}
            fullWidth={true}
            maxWidth={"sm"}
            MaCQ={this.state.Editting_MaCQ}
            EditMode={this.state.showConfirmXoa ? "xoa" : "edit"}
            onClose={(result) =>
              this.setState(
                {
                  open_edit_sukien: false,
                  Editting_MaCQ: undefined,
                  showConfirmXoa: false,
                },
                () => {
                  if (result === true) this.handleSearch();
                }
              )
            }
          />
        ) : null}
      </>
    );
  }
}
const styles = (theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  gridContainer: {
    height: "100vh",
  },
});

export default withStyles(styles, { withTheme: true })(CoQuanPage);
